module.exports = __webpack_public_path__ + "img/help_search_small.47d020aa.png";